import { RotationSprite } from './RotationSprite';
import { DropItem } from './DropItem';
import { GameObjectAttributes } from './CustomAttributes';
import { name_to_attributes } from './dataClasses/Mappings';
import { Creature } from './Creature';

export class Landscape extends RotationSprite {
  wiggling: boolean = false;
  wiggleCount: number = 0;
  maxWiggles: number = 7;
  health: number;
  sound: Phaser.Sound.BaseSound;
  static rockSound: Phaser.Sound.BaseSound;
  static bushSound: Phaser.Sound.BaseSound;
  constructor(data, private bodies: MatterJS.BodiesFactory, health: integer) {
    super(data);
    this.health = health;

    var collider = bodies.circle(this.x, this.y, 20, {
      isSensor: false,
      label: 'landscapeCollider',
    });
    this.setExistingBody(collider);
    if (this.attributes.mass <= 0) {
      // Setup collider and sensor for trees
      this.setStatic(true);
      this.setOrigin(0.5, 0.75);
    } else {
      this.setMass(this.attributes.mass);
      this.setFrictionAir(0.99);
      this.setFrictionStatic(0.99);
      this.setFriction(0.99);
      this.setBounce(0.99);
    }


    if (this.attributes.type == 'stone') {
      this.sound = Landscape.rockSound;
    } else if (this.attributes.type == 'tree') {
      this.sound = Landscape.bushSound;
    }
  }

  static preload(scene) {
    // load landscapes atlas
    scene.load.atlas(
      'landscapes',
      'assets/landscapes/landscapes.png',
      'assets/landscapes/landscapes_atlas.json'
    );

    scene.load.audio('tree', 'assets/audio/tree.mp3');
    scene.load.audio('rock', 'assets/audio/rock.mp3');
    scene.load.audio('bush', 'assets/audio/bush.mp3');
  }

  preUpdate(time: number, delta: number) {
    if (!this.wiggling) {
      this.angle = -this.scene.compassAngle;// player.angle;
    } else {
      if (this.wiggleCount == this.maxWiggles) {
        this.wiggling = false;
        this.wiggleCount = 0;

        if (this.health > 0) {
          console.log(this.health);
          this.health--;

          // Randomly select a drop item from the list
          const item_name: string =
            this.drops[Math.floor(Math.random() * this.drops.length)];

          let offset = new Phaser.Math.Vector2(0, 0);
          if (this.attributes.type == 'tree') {
            offset = Phaser.Math.RandomXY(offset, 50);
            offset.y = Math.abs(offset.y);
          }

          // Get the attributes of the dropped item
          let drop_attributes: GameObjectAttributes =
            name_to_attributes.get(item_name);

          // Determine if we are dropping a item, a creature, or an enemy
          if (drop_attributes.type == 'item') {
            // Drop a new object
            console.log(`dropping a ${item_name} Item`);
            this.droppedItems.push(
              new DropItem({
                scene: this.scene,
                x: this.x + offset.x,
                y: this.y + offset.y,
                frame: item_name,
              })
            );
          }
          else if(item_name === 'brown_rock'){
            // Drop a new object
            console.log(`dropping a ${item_name} Item`);
            for(let i=0; i<3; i++){
              this.droppedItems.push(
                new DropItem({
                  scene: this.scene,
                  x: this.x + offset.x,
                  y: this.y + offset.y,
                  frame: item_name,
                })
              );
            }
          }
          else if (drop_attributes.type == 'creature') {
            // drop a creature
            console.log(`creature name: ${item_name}`);
            var creature = new Creature(
              {
                scene: this.scene,
                x: this.x + offset.x,
                y: this.y + offset.y,
                texture: item_name,
              },
              this.bodies,
              drop_attributes.aggressive
            );
            this.droppedItems.push(creature);
            this.scene.activeCreatures.push(creature);
          }
        }
      } else {
        if (this.wiggleCount == 0) {
          this.sound.play();
        }
        if (this.drops.length > 0) {
          // Wiggle back and forth 6 deg
          this.angle =
            - this.scene.compassAngle + (2 * (this.wiggleCount % 2) - 1) * 6;
        }
        this.wiggleCount += 1;
      }
    }
  }
}
